import React, { useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import "./App.css";
import HomePage from "./HomePage";
import ProductPage from "./ProductPage";
import DemoPage from "./DemoPage";
import ChatsPage from "./ChatsPage";
import DutyFreeCopilotPage from "./DutyFreeCopilotPage";
import AusiliumDemoPage from "./AusiliumDemoPage";
import RetailCopilotPage from "./RetailCopilotPage";
import RetailCustomerPage from "./RetailCustomerPage";
import JewelleryCopilotPage from "./JewelleryCopilotPage";
import JewelleryCustomerPage from "./JewelleryCustomerPage";
import { RETAIL_DEMO_PATH } from "./retailDemo";
import { JEWELLERY_DEMO_PATH } from "./jewelleryDemo";
import { UserProvider } from "./contexts/UserContext";
import { KODLY_WIDGET_ORIGIN } from "./kodlyWidgetOrigin";

const KODLY_WIDGET_TOKEN =
  process.env.NODE_ENV === "development"
    ? process.env.REACT_APP_KODLY_WIDGET_TOKEN
    : "REACT_APP_KODLY_WIDGET_TOKEN_PLACEHOLDER";

function KodlyWidgetIntegration() {
  useEffect(() => {
    if (!KODLY_WIDGET_TOKEN) {
      console.error("REACT_APP_KODLY_WIDGET_TOKEN is not configured");
      return;
    }

    if (document.getElementById("kodly-ai-agent-loader")) {
      return;
    }

    const script = document.createElement("script");
    script.id = "kodly-ai-agent-loader";
    script.src = `${KODLY_WIDGET_ORIGIN}/loader.js?token=${encodeURIComponent(KODLY_WIDGET_TOKEN)}`;
    script.async = true;
    document.head.appendChild(script);

    return () => {
      script.remove();
    };
  }, []);

  return null;
}

// Kodly widget runs on tenant-simulation routes. /chats has its own Chatwoot
// embed for testing the native widget in isolation, and the duty free demo
// boots its own chat docked: the loader boots once per page, so the default
// widget arriving first would keep that one from booting. The Ausilium demo boots
// its own chat for the same reason, and so do the two pages of the retail and jewellery demos.
const ROUTES_WITH_OWN_WIDGET = [
  "/chats",
  "/demo-duty-free-copilot",
  "/demo-ausilium",
  RETAIL_DEMO_PATH,
  `${RETAIL_DEMO_PATH}/site`,
  JEWELLERY_DEMO_PATH,
  `${JEWELLERY_DEMO_PATH}/site`,
];

function ConditionalKodlyWidget() {
  const location = useLocation();
  if (ROUTES_WITH_OWN_WIDGET.includes(location.pathname)) {
    return null;
  }
  return <KodlyWidgetIntegration />;
}

// Componente principal da aplicação
function AppContent() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<DemoPage />} />
        <Route path="/produto/:slug" element={<ProductPage />} />
        <Route path="/demo" element={<HomePage />} />
        <Route path="/chats" element={<ChatsPage />} />
        <Route
          path="/demo-duty-free-copilot"
          element={<DutyFreeCopilotPage />}
        />
        <Route path="/demo-ausilium" element={<AusiliumDemoPage />} />
        <Route path={RETAIL_DEMO_PATH} element={<RetailCopilotPage />} />
        <Route path={`${RETAIL_DEMO_PATH}/site`} element={<RetailCustomerPage />} />
        <Route path={JEWELLERY_DEMO_PATH} element={<JewelleryCopilotPage />} />
        <Route path={`${JEWELLERY_DEMO_PATH}/site`} element={<JewelleryCustomerPage />} />
      </Routes>

      {/* Kodly widget embeds on tenant-simulation routes (skips ROUTES_WITH_OWN_WIDGET). */}
      <ConditionalKodlyWidget />
    </Router>
  );
}

function App() {
  return (
    <UserProvider>
      <AppContent />
    </UserProvider>
  );
}

export default App;
